export interface PeriodOptions {
  days?: number;
  months?: number;
  years?: number;
}

export const calculatePeriod = (
  startDate: Date,
  { days = 0, months = 0, years = 0 }: PeriodOptions = {},
): Date => {
  const start = new Date(startDate);
  let minusOneDay = true;

  const year = start.getFullYear() + years;
  const month = start.getMonth() + months;
  const day = start.getDate();

  let tentative = new Date(year, month, day);
  const expectedMonth = ((month % 12) + 12) % 12;

  if (tentative.getMonth() !== expectedMonth) {
    tentative = new Date(year, month + 1, 0);
    minusOneDay = false;
  }

  const end = new Date(tentative);
  if (days > 0) {
    end.setDate(end.getDate() + days);
  }

  if (minusOneDay) {
    end.setDate(end.getDate() - 1);
  }

  return end;
};
